import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZellerLogoNoFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 69,
	height: 24,
	viewBox: "0 0 69 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M31.587 0H34.6488V19.3959H31.587V0Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.399994 10.0768V7.01496H12.7125V9.24653L4.97404 18.4299H12.7125V21.4917H0.399994V19.2622L8.14364 10.0768H0.399994Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.1848 4.6041H37.123V24H40.1848V4.6041Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.1213 8.68066C64.4087 7.32182 66.036 6.68645 68.0975 6.74035L68.6013 6.75175V9.85708L68.0799 9.84983C67.2507 9.85086 64.4439 10.0582 63.1213 12.6815V21.4928H60.0595V7.01502H63.1213V8.68066Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M26.3041 17.2006C25.1142 18.291 23.775 18.8207 22.2089 18.8207C19.8021 18.8207 18.1945 17.7386 17.6587 15.7671H28.6621L28.7098 15.2935C28.9627 12.78 28.3459 10.536 26.9716 8.97501C25.7029 7.53325 23.8403 6.73929 21.7279 6.73929C17.526 6.73929 14.4756 9.88712 14.4756 14.2259C14.4756 18.5646 17.6048 21.7664 22.2617 21.7664C24.4052 21.7664 26.1838 21.1009 27.8588 19.6727L28.1822 19.3959L26.6347 16.8969L26.303 17.1996L26.3041 17.2006ZM21.7279 9.68708C23.861 9.68708 25.2924 10.8666 25.6811 12.9323H17.6068C18.065 10.8956 19.5917 9.68708 21.7269 9.68708H21.7279Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M50.7394 18.8207C52.3055 18.8207 53.6447 18.291 54.8346 17.2006L54.8335 17.1996L55.1652 16.8969L56.7127 19.3959L56.3893 19.6727C54.7143 21.1009 52.9357 21.7664 50.7922 21.7664C46.1353 21.7664 43.0061 18.5646 43.0061 14.2259C43.0061 9.88712 46.0565 6.73929 50.2584 6.73929C52.3708 6.73929 54.2334 7.53325 55.5021 8.97501C56.8764 10.536 57.4932 12.78 57.2403 15.2935L57.1926 15.7671H46.1892C46.725 17.7386 48.3326 18.8207 50.7394 18.8207ZM54.2116 12.9323C53.8229 10.8666 52.3915 9.68708 50.2584 9.68708H50.2574C48.1222 9.68708 46.5955 10.8956 46.1373 12.9323H54.2116Z",
			fill: "currentColor"
		})
	]
});
export default SvgZellerLogoNoFill;
